import { render, staticRenderFns } from "./Freeze.vue?vue&type=template&id=42c7f02c&scoped=true&"
import script from "./Freeze.vue?vue&type=script&lang=js&"
export * from "./Freeze.vue?vue&type=script&lang=js&"
import style0 from "./Freeze.vue?vue&type=style&index=0&id=42c7f02c&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "42c7f02c",
  null
  
)

export default component.exports